angular.module('impactx.disposition').controller('DispositionWaitListCtrl', [
    '$mdDialog',
    '$scope',
    '$redirect',
    '$context',
    'dataGen',
    DispositionWaitListCtrl]);

function DispositionWaitListCtrl($mdDialog, $scope, $redirect, $context, dataGen)
{
    var ctrl = this;
    this.status = "wait";
    $scope.$watch(function() {
        return ctrl.status;
    }, function(current, original) {
        if (current == "done")
            $redirect.redirectTo(  null,"/dispositiondone");
    });
    this.itemDetails = function(ev, dispositionId)
    {
        $mdDialog.show({
                controller: "DispositionWaitDialogCtrl",
                templateUrl: 'modules/disposition/templates/dispositionworkdialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dispositionId: dispositionId
                }
            })
            .then(function (answer)
            {
                if (answer !== false)
                {
                    $context.refreshBasket({}, dataGen, $context);
                    $redirect.redirectTo(null,"/basket");
                }
            });
    };
    this.meta = {
        rowTemplate: 'modules/disposition/templates/dispositionworklist.row.tmpl.html',
        filtersTemplate: 'modules/disposition/templates/dispositionworklist.filters.tmpl.html',
        isSelectAble: false,
        endpoint: '/disposition/dispositionwait',
        ctrl: this,
        id: "dispositionwait"
    };
    this.getMeta = function ()
    {
        return this.meta;
    };
}
